import React from "react";
import { MessageCircle, Twitter } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-12 px-4 border-t border-gray-800">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          
          {/* Brand */}
          <div className="text-center md:text-left flex items-center gap-4">
            <a 
              href="/"
              onClick={(e) => {
                e.preventDefault();
                window.location.reload();
              }}
            >
              <img 
                src="https://customer-assets.emergentagent.com/job_telegramcrypto/artifacts/c1vqzvr8_final%20logo%20TG4Crypto%20black%202.png"
                alt="TG4Crypto"
                className="h-8 w-auto cursor-pointer hover:opacity-80 transition-opacity duration-300"
                style={{ 
                  filter: 'brightness(0) saturate(100%) invert(70%) sepia(89%) saturate(2873%) hue-rotate(140deg) brightness(104%) contrast(101%)'
                }}
              />
            </a>
            <div>
              <p className="body-medium">
                Professional Telegram setup services for crypto projects
              </p>
            </div>
          </div>

          {/* Social Links */}
          <div className="flex items-center gap-6">
            <a
              href="https://t.me/TG4Crypto"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-white hover:text-cyan-400 dark-hover transition-colors duration-300"
            >
              <MessageCircle size={24} />
              <span>Telegram</span>
            </a>
            
            <a
              href="https://x.com/tg4crypto"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-white hover:text-cyan-400 dark-hover transition-colors duration-300"
            >
              <Twitter size={24} />
              <span>Twitter</span>
            </a>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-8 pt-8 border-t border-gray-800 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="body-muted">
            © {currentYear} TG4Crypto. All rights reserved.
          </p>
          
          <div className="flex items-center gap-6">
            <button 
              onClick={() => window.dispatchEvent(new CustomEvent('showDisclaimer'))}
              className="text-white hover:text-cyan-400 dark-transition cursor-pointer font-medium underline"
            >
              Disclaimer
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;